import { render } from "./LineChartB.vue?vue&type=template&id=496f5ad0&scoped=true"
import script from "./LineChartB.vue?vue&type=script&lang=ts"
export * from "./LineChartB.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-496f5ad0"

export default script